import React from 'react';

function ParentSelectorTree({ nodes, selectedNode, onSelect, theme }) {
  // 初期表示ですべてのノードを展開
  const getAllNodeIds = (nodeList) => {
    const ids = [];
    const traverse = (nodes) => {
      for (const node of nodes) {
        ids.push(node.location_node_id);
        if (node.children && node.children.length > 0) {
          traverse(node.children);
        }
      }
    };
    traverse(nodeList);
    return ids;
  };

  const [expandedNodes, setExpandedNodes] = React.useState(new Set(getAllNodeIds(nodes)));

  const toggleExpand = (nodeId) => {
    const newExpanded = new Set(expandedNodes);
    if (newExpanded.has(nodeId)) {
      newExpanded.delete(nodeId);
    } else {
      newExpanded.add(nodeId);
    }
    setExpandedNodes(newExpanded);
  };

  const renderNode = (node, level = 0, parentPath = '') => {
    // 親のパスを含む一意のキーを生成
    const nodePath = parentPath ? `${parentPath}-${node.location_node_id}` : `root-${node.location_node_id}`;
    const hasChildren = node.children && node.children.length > 0;
    const isExpanded = expandedNodes.has(node.location_node_id);
    const isSelected = selectedNode && selectedNode.location_node_id === node.location_node_id;
    const isLeaf = node.location_node_type?.has_rfid; // 最下層（RFID設定可能）かどうか

    return (
      <div key={nodePath}>
        <div
          style={{
            paddingLeft: `${level * 24 + 12}px`,
            paddingRight: '12px',
            paddingTop: '10px',
            paddingBottom: '10px',
            margin: '2px 0',
            background: isLeaf ? (theme === 'dark' ? '#2f3844' : '#f7fafc') : (isSelected ? (theme === 'dark' ? '#1a3a52' : '#e6f7ff') : (theme === 'dark' ? '#252d3a' : '#fff')),
            border: isSelected ? '2px solid #1890ff' : (theme === 'dark' ? '1px solid #3d4858' : '1px solid #e2e8f0'),
            borderRadius: '4px',
            cursor: isLeaf ? 'not-allowed' : 'pointer',
            fontSize: '14px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            fontWeight: isSelected ? 'bold' : 'normal',
            opacity: isLeaf ? 0.5 : 1
          }}
          onClick={() => !isLeaf && onSelect(node)}
          title={isLeaf ? '最下層（RFID設定可能）のため親として選択できません' : ''}
        >
          {hasChildren && (
            <span
              onClick={(e) => {
                e.stopPropagation();
                toggleExpand(node.location_node_id);
              }}
              style={{ cursor: 'pointer', userSelect: 'none', width: '16px', flexShrink: 0 }}
            >
              {isExpanded ? '▼' : '▶'}
            </span>
          )}
          {!hasChildren && <span style={{ width: '16px', flexShrink: 0 }}></span>}
          <span style={{ flex: 1 }}>
            📍 {node.location_name}
          </span>
          <span style={{ color: '#718096', fontSize: '12px', flexShrink: 0 }}>
            {node.type_name_ja}
          </span>
        </div>
        {hasChildren && isExpanded && (
          <div>
            {node.children.map((child) => renderNode(child, level + 1, nodePath))}
          </div>
        )}
      </div>
    );
  };

  return (
    <div>
      {nodes.map((node) => renderNode(node, 0, ''))}
    </div>
  );
}

export default ParentSelectorTree;
